import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// Views
import Dashboard from './views/Dashboard';
import Settings from './views/Settings';
import Maintenance from './views/Maintenance'
import SignIn from './views/SignIn';
import EstadoOperativo from './views/ControlOperativo'
import SummaryObjectives from './views/ServiceByObjective'
import UnderDevelopment from './views/UnderDevelopment';
import NotFound from './views/NotFound';
import GeneralStatusView from './views/GeneralStatusView';
import ManageObjectives from './views/ManageObjective';
import SpecialAccess from './views/SpecialAccess';
import Symbology from './views/Symbology';
//import QuickViewIspView from './views/QuickViewIspView'
import QuickViewIspViewLights from './views/QuickViewIspLights';
import ComparisonObjectives from './views/ComparisonObjectives';

// Views Atentus
import Special from './views/Special'
import Online from './views/Online';


//HOCs 

//Autenticación
import authGuard from './HOCs/authGuard'

export default class Routes extends Component {
  render() {
    return (
      <Switch>
        <Redirect
          exact
          from="/"
          to="/sign-in"
        />
        <Route
          component={authGuard(Dashboard)}
          exact
          path="/quickview"
        />
        <Route
          component={authGuard(EstadoOperativo)}
          exact
          path="/estadoOperativo"
        />
        <Route
          component={authGuard(SummaryObjectives)}
          exact
          path="/SummaryObjectives"
        />
        <Route
          component={authGuard(GeneralStatusView)}
          exact
          path="/generalStatus"
        />
        <Route
          component={authGuard(QuickViewIspViewLights)}
          exact
          path="/quickviewisplights"
        />
        <Route
          component={authGuard(Online)}
          exact
          path="/online/:objetivo_id/:nombre_objetivo/:nombre_servicio_unificado"
        />
        <Route
          component={authGuard(Special)}
          exact
          path="/especial/:objetivo_id/:nombre_objetivo"
        />
        <Route
          component={authGuard(Maintenance)}
          exact
          path="/Maintenance"
        />
        <Route
          component={authGuard(Settings)}
          exact
          path="/settings"
        />
        <Route
          component={authGuard(ManageObjectives)}
          exact
          path="/manageObjectives"
        />

        <Route
          component={SignIn}
          exact
          path="/sign-in"
        />
        <Route
          component={UnderDevelopment}
          exact
          path="/under-development"
        />
        <Route
          component={NotFound}
          exact
          path="/not-found"
        />
        <Route
          component={(SpecialAccess)}
          exact
          path="/specialAccess"
        />
        <Route
          component={(Symbology)}
          exact
          path="/simbologia"
        />
        <Route
          component={authGuard(ComparisonObjectives)}
          exact
          path="/comparisonObjectives"
        />
        <Redirect to="/not-found" />
      </Switch>
    );
  }
}
